import { getDefaultAudioUrl, getDefaultVideoUrl } from "./convertNodes";
import { toPlainTextBase } from "./to-plain-text-base";
const toPlainTextSync = (content, options = {}) => {
  var _a;
  const gen = toPlainTextBase(content, options.delimiter, options.addLinksToText);
  let next = gen.next();
  while (!next.done) {
    switch (next.value.command) {
      case "getImageUrl": {
        const url = options.urlShortener ? (_a = options.urlShortener) == null ? void 0 : _a.call(options, next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      case "getVideoUrl": {
        const url = options.getVideoUrl ? options.getVideoUrl(next.value.data) : getDefaultVideoUrl(next.value.data);
        next = gen.next(url);
        break;
      }
      case "getVideoEmbeddedUrl": {
        const url = options.getVideoEmbeddedUrl ? options.getVideoEmbeddedUrl(next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      case "getAudioUrl": {
        const url = options.getAudioUrl ? options.getAudioUrl(next.value.data) : getDefaultAudioUrl(next.value.data);
        next = gen.next(url);
        break;
      }
      case "getGifUrl": {
        const url = options.getGifUrl ? options.getGifUrl(next.value.data) : next.value.data;
        next = gen.next(url);
        break;
      }
      default:
        return "";
    }
  }
  return next.value;
};
export {
  toPlainTextSync
};
//# sourceMappingURL=toPlainTextSync.js.map
